import { combineReducers } from 'redux';
import ErrorReducer from './errorReducer';
import createTransaction from './user/createTransaction';
import fetchReducer from './user/fetchCoins';
import getAccountInfo from './user/getAccountInfo';
import getBankList from './user/getBankList';
import coinPrice from './user/coinPrice';
import loginReducer from './user/dashboard/login';
import registerReducer from './user/dashboard/register';
import getUserReducer from './user/dashboard/getUser';
import forgotPasswordReducer from './user/dashboard/forgotPassword';
import changePasswordReducer from './user/dashboard/changePassword';
import fetchAllTransReducer from './user/dashboard/fetchAllTransactions';
import fetchEachCoinReducer from './user/dashboard/fetchEachCoin';


const rootReducer = combineReducers({
  bankList: getBankList,
  acctInfo: getAccountInfo,
  error: ErrorReducer,
  createTrans: createTransaction,
  coins: fetchReducer,
  price: coinPrice,


  // Auth and New User
  login: loginReducer,
  register: registerReducer,
  getAuthUser: getUserReducer,
  forgotState: forgotPasswordReducer,
  changePword: changePasswordReducer,

  transactions: fetchAllTransReducer,
  eachCoinData: fetchEachCoinReducer,
});

export default rootReducer;